import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService, Task, TaskService } from '../../core';
import { INotification, NotificationService } from './services/notification.service';

export enum EnumNotificationsSection {
  Notifications = 'notifications',
  Tasks = 'tasks'
}

@Component({
  selector: 'sgt-notification-menu',
  templateUrl: './notification-menu.component.html',
  styleUrls: ['./notification-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationMenuComponent implements OnInit, OnDestroy {
  readonly tabs = EnumNotificationsSection;

  notifications: INotification[] = [];
  tasks: Task[] = [];

  isOpen = false;
  activeSection: EnumNotificationsSection = EnumNotificationsSection.Tasks;

  private notificationsSub?: Subscription;
  private tasksSub?: Subscription;

  constructor(
    private elementRef: ElementRef,
    private notificationService: NotificationService,
    private taskService: TaskService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.notificationsSub = this.notificationService.notifications$.subscribe((notifications) => {
      this.notifications = notifications;
      this.cdr.markForCheck();
    });
    this.tasksSub = this.taskService.tasks$.subscribe((tasks) => {
      this.tasks = tasks;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.notificationsSub?.unsubscribe();
    this.tasksSub?.unsubscribe();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      event.stopPropagation();
      this.close();
    }
  }

  get unreadCount(): number {
    return this.notifications.filter((n) => !n.read).length;
  }

  get unreadTasksCount(): number {
    return this.tasks.filter((t) => !t.read).length;
  }

  get totalBadgeCount(): number {
    return this.unreadTasksCount;
  }

  switchSection(section: EnumNotificationsSection): void {
    this.activeSection = section;
  }

  toggle(): void {
    if (this.isOpen) {
      this.close();
    } else {
      this.isOpen = true;
    }
  }

  close(): void {
    this.isOpen = false;
    this.activeSection = EnumNotificationsSection.Tasks;
  }

  onSeeAllNotifications(): void {
    this.close();
  }

  onClearAllTasks(): void {
    this.taskService.clearAll();
  }

  onShowTaskError(task: Task): void {
    this.taskService.markAsRead(task);
    this.messageService.error(task.messageError, task.titleError, task.error);
    this.close();
  }
}
